module.exports = __webpack_public_path__ + "img/8market5_dog1.639252db.png";